"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalResponseMapper = void 0;
var LegalResponseMapper = /** @class */ (function () {
    function LegalResponseMapper(data) {
        this.localData = data;
    }
    LegalResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return LegalResponseMapper;
}());
exports.LegalResponseMapper = LegalResponseMapper;
//# sourceMappingURL=LegalResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/LegalResponseMapper.js
// module id = 2060
// module chunks = 8